import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';
import { IconSystemV2ArrowArrowLeftLine } from '@doltech/icons/SystemV2/IconSystemV2ArrowArrowLeftLine';
import { IconSystemV2ArrowArrowRightLine } from '@doltech/icons/SystemV2/IconSystemV2ArrowArrowRightLine';
import { DUAL_TOGGLE } from '../../../shared/constant';
import { Separator } from '@doltech/ui/lib/figma/Layout/Landing/Content/Separator';

const Main = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: center;
  background-color: ${colorsV2.white100};
  &.border-style {
   border-bottom: 1px solid ${colorsV2.grey20};
  }
  &.audio {
    padding: 16px 20px;
  }

  &.video {
    padding: 16px 20px;
  }
  .pointer {
    cursor: pointer;
  }
`;

const Content = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
`;

const Toggle = styled.div`
  display: grid;
  grid-auto-flow: column;
  padding: 4px;
  border: 1px solid ${colorsV2.grey20};
  border-radius: 12px;
`;

const ToggleItem = styled.div`
  padding: 8px 6px;
  border-radius: 8px;
  cursor: pointer;
  &.selected {
    background: ${colorsV2.grey10};
    span {
      color: ${colorsV2.grey180};
    }
  }
`;

interface TitleQuizProps {
  totalQuestion: number;
  blankWordCount: number;
  currentQuestion: number;
  type?: 'audio' | 'video';
  dualToggle?: string;
  isToggleVisible?: boolean;
  isBackNextVisible?: boolean;
  onChangeToggle?: (type: string) => void;
  next?: () => void;
  prev?: () => void;
}

export const TitleQuiz = (props: TitleQuizProps) => {
  const {
    blankWordCount,
    totalQuestion,
    currentQuestion,
    type = 'audio',
    dualToggle,
    isToggleVisible = false,
    isBackNextVisible = false,
    onChangeToggle,
    next,
    prev,
  } = props;
  return (
    <Main className={cl('title-quiz', type, {'border-style': dualToggle === DUAL_TOGGLE.SUGGEST_TEXT})}>
      <Content>
        {isBackNextVisible && (
          <IconSystemV2ArrowArrowLeftLine
            size={20}
            color="grey100"
            className="pointer"
            onClick={prev}
          />
        )}
        <ResponsiveTypography.Paragraph variant="semi-bold/16-24" color="grey180">
          Câu {currentQuestion}/{totalQuestion}
        </ResponsiveTypography.Paragraph>
        {isBackNextVisible && (
          <IconSystemV2ArrowArrowRightLine
            size={20}
            color="grey100"
            className="pointer"
            onClick={next}
          />
        )}
        {!isBackNextVisible && (
          <Separator width="3px" height="3px" backgroundColor="black20" variant="dot" />
        )}
        <ResponsiveTypography.Paragraph variant="medium/16-24" color="grey120">
          {blankWordCount} từ
        </ResponsiveTypography.Paragraph>
      </Content>
      {isToggleVisible && (
        <Toggle>
          <ToggleItem
            onClick={() => onChangeToggle?.(DUAL_TOGGLE.FREE_TEXT)}
            className={cl({ selected: dualToggle === DUAL_TOGGLE.FREE_TEXT })}
          >
            <ResponsiveTypography.Paragraph variant="bold/12-20" color="grey120">
              EASY
            </ResponsiveTypography.Paragraph>
          </ToggleItem>
          <ToggleItem
            onClick={() => onChangeToggle?.(DUAL_TOGGLE.SUGGEST_TEXT)}
            className={cl({ selected: dualToggle === DUAL_TOGGLE.SUGGEST_TEXT })}
          >
            <ResponsiveTypography.Paragraph variant="bold/12-20" color="grey120">
              HARD
            </ResponsiveTypography.Paragraph>
          </ToggleItem>
        </Toggle>
      )}
    </Main>
  );
};
